import { DefaultProgramId, ProgramId } from 'modules/program';

import { BannerLinkConfig } from 'features/banners';

const DefaultLinkId = 'home';

type TGetLinkUrlOptions = {
  programId?: ProgramId;
  linkId?: string;
};

function getLinkUrl({ programId, linkId }: TGetLinkUrlOptions): string {
  const programLinks = BannerLinkConfig[programId] ?? BannerLinkConfig[DefaultProgramId];
  return programLinks[linkId] ?? programLinks[DefaultLinkId];
}

export { DefaultLinkId, getLinkUrl };
